import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";

import { CustomShippingAccountNumberState } from "@solveindustrial/Store/State/Custom/ShippingAccount/ShippingAccountNumberState";
import { Draft } from "immer";

export const initialState: CustomShippingAccountNumberState = {
    shippingAcountNumber: "",
};

export const customShippingAcountNumberReducer = createTypedReducer(initialState, {
    "Custom/ShippingAccountNumberState/SetShippingAccountNumber": (
        draft: Draft<CustomShippingAccountNumberState>,
        { shippingAcountNumber }: { shippingAcountNumber: string },
    ) => ({ ...draft, shippingAcountNumber }),

    "Custom/ShippingAccountNumberState/ResetShippingAccountNumber": (
        draft: Draft<CustomShippingAccountNumberState>,
    ) => ({ ...draft, shippingAcountNumber: "" }),
});
